import { styled } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import { drawerWidth, miniDrawerWidth } from "../../../../../config";
import { useMediaQuery } from "@mui/material";

const HeaderAppBar = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => {
  const matchDownMD = useMediaQuery(theme.breakpoints.down("md"));

  return matchDownMD
    ? {
        backgroundColor: "#000000",
      }
    : {
        // zIndex: theme.zIndex.drawer + 1,
        backgroundColor: "#ffffff",
        transition: theme.transitions.create(["width", "margin"], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        ...(open && {
          marginLeft: drawerWidth,
          width: `calc(100% - ${drawerWidth}px)`,
          transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
        }),
        ...(!open && {
          marginLeft: miniDrawerWidth,
          width: `calc(100% - ${miniDrawerWidth}px)`,
          transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
        }),
      };
});

export default HeaderAppBar;
